// Chrome 1 - 71
export const isChrome = () => !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);